module.exports = __webpack_public_path__ + "39e0824676f1b44389cef8fbbc50e142.png";